module.exports = __webpack_public_path__ + "img/sparkles.39120465.svg";